import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useLoading } from '../context/LoadingContext';

const GlobalLoader = () => {
  const { isLoading } = useLoading();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
      open={isLoading}
    >
      <CircularProgress color="inherit" size={60} />
    </Backdrop>
  );
};

export default GlobalLoader;
